// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DogHint_wrapper__o7WJG","hint":"DogHint_hint__X7nPx","decorated":"DogHint_decorated__HnsSv"};